(function () {
  var root = document.documentElement;
  var KEY = 'xl-accent';

  /* ---------- accentfärg: besökarens val sparas per webbläsare ---------- */
  function baseColor() { return (window.XL_BASE && window.XL_BASE.c) || ''; }

  function applyAccent(c, rgb) {
    root.style.setProperty('--accent', c);
    root.style.setProperty('--accent-rgb', rgb);
    document.querySelectorAll('.sw').forEach(function (x) {
      x.setAttribute('aria-pressed', (x.dataset.c || '').toLowerCase() === c.toLowerCase() ? 'true' : 'false');
    });
  }

  function savedAccent() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY));
      // Har butikens grundfärg ändrats sedan valet gjordes? Kasta det gamla.
      if (s && s.base !== baseColor()) { localStorage.removeItem(KEY); return null; }
      return s;
    } catch (e) { return null; }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.sw');
    if (!sw) return;
    applyAccent(sw.dataset.c, sw.dataset.rgb);
    try { localStorage.setItem(KEY, JSON.stringify({ c: sw.dataset.c, rgb: sw.dataset.rgb, base: baseColor() })); } catch (err) {}
  });

  /* ---------- mobilmeny ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-burger]')) {
      var m = document.querySelector('.mobmenu');
      if (m) m.classList.toggle('open');
    }
  });

  /* ---------- produktbilder ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var main = document.querySelector('[data-shot]');
    if (main) {
      var img = main.querySelector('img');
      if (img) { img.src = t.dataset.full; img.srcset = ''; }
      else { main.innerHTML = '<img src="' + t.dataset.full + '" alt="">'; }
    }
    document.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
    t.setAttribute('aria-current', 'true');
  });

  /* ---------- variantval: pris, lager, köpknapp, köpfält ---------- */
  document.addEventListener('change', function (e) {
    var r = e.target.closest('input[name="xl-variant"]');
    if (!r) return;
    var d = r.dataset;

    var idField = document.querySelector('[data-variant-id]');
    if (idField) idField.value = r.value;

    var now = document.querySelector('[data-price-now]');
    if (now) now.textContent = d.price;

    var was = document.querySelector('[data-price-was]');
    if (was) { was.textContent = d.compare || ''; was.style.display = d.compare ? '' : 'none'; }

    var cut = document.querySelector('[data-price-cut]');
    if (cut) { cut.textContent = d.cut || ''; cut.style.display = d.cut ? '' : 'none'; }

    var per = document.querySelector('[data-price-per]');
    if (per) { per.textContent = d.per || ''; per.style.display = d.per ? '' : 'none'; }

    var stock = document.querySelector('[data-stock]');
    if (stock) {
      var inStock = d.available === 'true';
      stock.classList.toggle('out', !inStock);
      var label = stock.querySelector('span:last-child');
      if (label) label.textContent = inStock ? stock.dataset.inText : stock.dataset.outText;
    }

    var btn = document.querySelector('[data-atc]');
    if (btn) {
      var ok = d.available === 'true';
      btn.disabled = !ok;
      btn.textContent = ok ? btn.dataset.label : btn.dataset.sold;
    }

    var dock = document.querySelector('[data-dock-label]');
    if (dock) dock.textContent = d.title + ' – ' + d.price;
  });

  /* ---------- rabattruta ---------- */
  function startPromo() {
    var box = document.querySelector('[data-promo]');
    if (!box) return;

    var delay = parseInt(box.dataset.delay, 10);
    if (isNaN(delay)) delay = 2000;
    setTimeout(function () { box.classList.add('on'); }, delay);

    var raw = (box.dataset.deadline || '').trim();
    var out = box.querySelector('[data-countdown]');
    if (!raw || !out) return;

    var end = new Date(raw.replace(' ', 'T'));
    if (isNaN(end.getTime())) return;

    function tick() {
      var ms = end - new Date();
      if (ms <= 0) { box.style.display = 'none'; return; }
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (d > 0) out.textContent = d + (d === 1 ? ' dag ' : ' dagar ') + h + ' tim';
      else if (h > 0) out.textContent = h + ' tim ' + m + ' min';
      else out.textContent = m + ' min ' + sec + ' sek';
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- autospelande, ljudlösa videor ---------- */
  function bootVideos() {
    var vids = document.querySelectorAll('video.xl-vid');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.volume = 0;
      v.setAttribute('muted', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { rootMargin: '150px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- varukorg: antal ---------- */
  document.addEventListener('change', function (e) {
    var q = e.target.closest('[data-qty]');
    if (!q) return;
    var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var line = q.dataset.qty;
    var val = Math.max(0, parseInt(q.value, 10) || 0);
    var row = q.closest('.cart-line');
    if (row) row.classList.add('busy');
    fetch(root_url + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: val })
    }).then(function () { window.location.reload(); })
      .catch(function () { window.location.href = root_url + 'cart/change?line=' + line + '&quantity=' + val; });
  });

  function boot() {
    var s = savedAccent();
    if (s && s.c) applyAccent(s.c, s.rgb);
    startPromo();
    bootVideos();
    if (document.querySelector('.dock')) document.body.classList.add('has-dock');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () { startPromo(); bootVideos(); });
})();
